import { render, staticRenderFns } from "./WorkActivitySujetoObligado.vue?vue&type=template&id=3540d7f6"
import script from "./WorkActivitySujetoObligado.vue?vue&type=script&lang=js"
export * from "./WorkActivitySujetoObligado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports